export default __webpack_public_path__ + "static/char-s-20-ja-0bd684c922cf8684ac16f74554cf73e3.png";